export const SET_SELECTED_TICKETS = 'SET_SELECTED_TICKETS';
export const SELECTED_DATE = 'SELECTED_DATE';
export const STEP = 'STEP';
export const RESET = 'RESET';
